import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faDownload,
  faPlus,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getDispatchAllExcelDownload,
  getDispatchEntryByDate,
  getDispatchExcelDownload,
  getDispatchList,
  getDispatchPdfDownload,
  putDispatch,
  getDispatchAllPdfDownload,
  getdispatchdispensersereialNo
} from "../../Service/AllDispatchAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import CloseDispatchForm from "./CloseDIspatchform";
import ToolTip from "../ToolTip";
export default () => {
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [isLoaded, setisLoaded] = useState(false);
  const [searchDispenserSerialNumber, setSearchDispenserSerialNumber] = useState("");
  const [searchPerformed, setSearchPerformed] = useState(false);
  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  //
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({ top: '44%', left: '61%' });
  //
  const [showForm, setShowForm] = useState(false);


  const handleShowForm = () => setShowForm(true);
  const handleHideForm = () => setShowForm(false);

  const handleCloseForm = () => {
    setShowForm(false); 
  };


  const handleMouseDown = (e) => {
  
    const rect = e.target.getBoundingClientRect();
    setIsDragging(true);
    setDragStart({
      x: e.clientX - rect.left,  
      y: e.clientY - rect.top,   
    });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
    
      const deltaX = e.clientX - dragStart.x;
      const deltaY = e.clientY - dragStart.y;

      setPosition({
        top: `${deltaY}px`,   
        left: `${deltaX}px`, 
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);


 



  useEffect(() => {
    getDispatch(); // Function call to get Dispatch list
    return () => { };
    // eslint-disable-next-line
  }, []);

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      await getDispatchList(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
          } else {
            swal("Sorry", "Dispatch data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    } else if (fromDate !== "" && toDate !== "") {
      await getDispatchEntryByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            console.log("totalSize", totalSize);
            console.log("data", data);
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
          } else {
            swal(
              "Sorry",
              "Dispatch data is not present for selected date",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  // Function declaration of get Dispatch list
  const getDispatch = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      setisLoaded(true);
      await getDispatchList(currentPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
            // setToDate("")
            // setFromDate("")
          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal("Failed", "Dispatch data is not present", "warning");
          }
        })
        .catch((error) => {
          console.log("Get Dispatch Error", error);
        });
      setisLoaded(false);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // const getDispatchListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log(fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // Function declaration for setting toDate on "todate" field change event
  // const getDispatchListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log(toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  const getDispatchListByDate = async () => {
    try {
      // setisLoaded(true);
      if (fromDate !== "" && toDate !== "") {

        await getDispatchEntryByDate(
          currentPage,
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        ).then((result) => {
          console.log("Get Dispatch Entry Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotalCount(result.data.totalElements);
            // setToDate("")
            // setFromDate("")

          } else {
            setEntries([]);
            setPageCount();
            setTotalCount();
            swal(
              "Sorry",
              "Dispatch data is not present for selected date.",
              "warning"
            );
          }
        });
      } else {
        swal("Failed", "Please select date", "error");
      }
      setisLoaded(false);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

 

  const getDispatchReportPdfDownload = async () => {
    try {


      if (fromDate !== "" && toDate !== "") {
        await getDispatchPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
      } else {

        await getDispatchAllPdfDownload();
      }

      setisLoaded(false);
    } catch (error) {
      console.log(error);
      setisLoaded(false);
      swal("Error", "failed to downlaod pdf", "error");
    }
  };


  const getDispatchReportExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      try {
        await getDispatchExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log("getDispatchExcelDownload error :-", error);
      }
    } else {
      try {
        await getDispatchAllExcelDownload();
        // setToDate("")
        // setFromDate("")
      } catch (error) {
        console.log(error);
        swal("Failed", "failed to downlaod pdf", "error");
      }
    }
  };

  const clearSearch = () => {
    setSearchDispenserSerialNumber('');
    setSearchPerformed(false);

    getDispatch();
  };
  const search = async (e) => {
    setSearchPerformed(true);
    console.log("e :-", e);
    if (!searchDispenserSerialNumber) {
      swal("Missing Serial Number", "Please enter the dispenser serial number", "warning").then(() => {
        clearSearch();
      });
      return;
    }

    try {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const result = await getdispatchdispensersereialNo(currentPage, searchDispenserSerialNumber, role, fkUserId, headers);
      // console.log("cheking data ", result?.content)
      // console.log("Searching for dispatch Dispenser Serial Number:", searchDispenserSerialNumber);

      if (result?.content?.length > 0) {
        const sortedData = result.content.sort((a, b) => b.pkUserId - a.pkUserId);
        setEntries(sortedData);
        setPageCount(1);
        setTotalCount(sortedData.length);

      } else {
        swal("No Data", "No records found for the given serial number", "info");

        setEntries([]);
      }
    } catch (error) {
      console.error("Search error:", error);
      swal("Failed", "Failed to fetch data, please try again", "error");
    }
  };




  // column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of dispatch list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Dispatch WO Status",
      editable: false,
      headerAlign: "left",
      style: {
        textTransform: "capitalize",
        textAlign: 'center'
      },
    },

    {
      dataField: "workOrderNo",
      text: "Production WO No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dispatchOrderNo",
      text: "Dispatch Wo Number",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser No",
      editable: false,
      headerAlign: "left",
    },

    {
      dataField: "dispatchDate",
      text: "Dispatch Wo Created on",
      editable: false,
      align: "center",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "dispatchTime",
      text: "Dispatch Wo created Time",
      align: "center",
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
      editable: false,
    },
    // {
    //   dataField: "closeDate",
    //   text: "Dispatch Wo closed on",
    //   editable: false,
    //   align: "center",
    //   formatter: (cell) => {
    //     return <>{moment(cell).format("DD-MMM-YYYY")}</>;
    //   },
    // },
    {
      dataField: "closeDate",
      text: "Dispatch Wo closed on",
      editable: false,
      align: "center",
      formatter: (cell) => {
        const formattedDate = moment(cell);
        if (!formattedDate.isValid()) {
          return 'Not Closed Yet  ';
        }
        return formattedDate.format("DD-MMM-YYYY");
      },
    }
    ,


    {
      dataField: "closeTime",
      text: "Dispatch Wo closed Time",
      align: "center",
      formatter: (cell) => {
        const formattedTime = moment(cell, "hh:mm A", true);
        if (!formattedTime.isValid()) {
          return <>{'Not Closed Yet'}</>;
        }
        return <>{formattedTime.format("hh:mm A")}</>;
      },

      editable: false,
    },
    {
      dataField: "cloureRemark",
      text: "Dispatch Closure remark",
      editable: false,
      headerAlign: "left",
      formatter: (cell, row) => {

        const text = cell || "";

        return (
          <div className="tooltip-container">
            <div className="truncated-text">{text}</div>
            {text.length > 20 && (
              <span className="tooltip-text">{row.cloureRemark || "No Remark"}</span>
            )}
          </div>
        );
      }

    },

    {
      dataField: "modelName",
      text: "Dispenser Config",
      editable: false,
      headerAlign: "left",
    },

    {
      dataField: "vehicleNo",
      text: "Vehicle No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "driverName",
      text: "Driver Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "driverContactNo",
      text: "Driver Contact No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "description",
      editable: false,
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },
    {
      dataField: "address",
      text: "Warehouse Address",
      editable: false,
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.address}</span>
          )}
        </div>
      )
    },
    {
      dataField: "customerFullName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },




    // {
    //   dataField: "dealerName",
    //   text: "Dealer Name",
    //   editable: false,
    //   headerAlign: "left",
    // },
    // {
    //   dataField: "dispatchType",
    //   text: "Dispatch Type",
    //   editable: false,
    //   headerAlign: "left",
    // },

    {
      dataField: "whoDidIt",
      text: "Dispatch Wo managed by",
      editable: false,
      headerAlign: "left",
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>


          <Row>
            <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
              <div className="form-group">
                <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy"
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
              <div className="form-group">
                <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy"
                  minDate={fromDate}
                  maxDate={new Date()}
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getDispatchListByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
            <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
              {role === "admin" || role === "back office" ? (
                <>
                  <div className="newadd" align="right">
                    <Link to="add-dispatch" className="btn btn-secondary">
                      <FontAwesomeIcon icon={faPlus} className="me-2" />
                      <span>Create Dispatch WO</span>{" "}
                    </Link>
                  </div>
                </>
              ) : (
                " "
              )}
            </Col>
          </Row>
          

          <ToolkitProvider
            keyField="id"
            search={false}
            columns={columns}
            data={entries}
            exportCSV={{ onlyExportFiltered: true, exportAll: false }}
          >
            {({ baseProps, searchProps, csvProps }) => (
              <Paginator.PaginationProvider
                pagination={Pagination({
                  custom: true,
                  disablePageTitle: true,
                  alwaysShowAllBtns: true,
                  totalSize: totalCount,
                  paginationTotalRenderer: customTotal,
                  onPageChange: handlePageChange,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <Card>
                    <Col xs={12} md={6} className="p-2">
                      <h5 className="head ">Dispatch Entry List</h5>
                    </Col>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row>
                          {/* Search Input */}
                          <Col xs={6} className="py-1 d-flex">
                            <input
                              type="search"
                              placeholder="Search by dispenser Sr No..."
                              value={searchDispenserSerialNumber}
                              onChange={(e) => setSearchDispenserSerialNumber(e.target.value)}
                              className="form-control searchinput"
                              style={{ marginRight: "10px" }}
                            />
                            <button className="btn btn-secondary" onClick={searchPerformed ? clearSearch : search}>
                              <FontAwesomeIcon icon={searchPerformed ? faTimes : faSearch} className="me-2" />
                              <span>{searchPerformed ? "Clear Serial Number" : "Search By Serial Number"}</span>
                            </button>
                          </Col>


                          <Col xs={6} className="py-1 d-flex">


                            {!showForm ? (
                              <ToolTip content="Click here to open dispatch wo closure form" direction="right">
                                <Button
                                  variant="dark"
                                  style={{ marginLeft: "10px" }}
                                  onClick={handleShowForm}
                                >
                                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                                  <span>Close Dispatch WO</span>
                                </Button>
                              </ToolTip>
                            ) : (
                              <ToolTip content="Click here to close  dispatch wo closure form" direction="right">
                                <Button
                                  variant="danger"
                                  style={{ marginLeft: "10px" }}
                                  onClick={handleCloseForm}
                                >
                                  <FontAwesomeIcon icon={faTimes} className="me-2" />
                                  <span>Close</span>
                                </Button>
                              </ToolTip>
                            )}


                          </Col>

                          {/* PDF & Excel Buttons Aligned to End */}
                          <Col xs={12} className="d-flex justify-content-end py-1">
                            <button className="btn btn-secondary" onClick={getDispatchReportPdfDownload}>
                              <FontAwesomeIcon icon={faDownload} className="me-2" />
                              <span>PDF</span>
                            </button>
                            <button className="btn btn-secondary mx-2" onClick={getDispatchReportExcelDownload}>
                              <FontAwesomeIcon icon={faDownload} className="me-2" />
                              <span>Excel</span>
                            </button>
                          </Col>
                        </Row>
                      </Card.Header>

                      {/* Table */}
                      <Table
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        rowClasses="border-bottom"
                        classes="table-flush dataTable-table"
                        filter={filterFactory()}
                        remote={{ pagination: true }}
                        headerClasses="header-class"
                        hover
                        striped
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            const changeRowData = {
                              selectedRow: row,
                              cellChange: newValue,
                              columnChange: column,
                            };
                            var newRowData = JSON.parse(JSON.stringify(changeRowData));
                            setChangeRowData(newRowData);
                            return { async: true };
                          },
                        })}
                        wrapperClasses="table-responsive"
                      />

                      {/* Pagination */}
                      <Card.Footer>
                        <Row>
                          <Col xs={12} md={6}></Col>
                          <Col xs={12} md={6} className="d-flex justify-content-end">
                            <Paginator.PaginationListStandalone {...paginationProps} />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                )}
              </Paginator.PaginationProvider>
            )}
          </ToolkitProvider>


          

          {showForm && (
            <div
              className="floating-form"
              style={{ top: position.top, left: position.left }}
              onMouseDown={handleMouseDown}
            >
              <div className="floating-form-header">
               
              </div>
              <div className="floating-form-body">
                <CloseDispatchForm />
              </div>
            </div>
          )
          }
        </>
      )}
    </>
  );
};
